var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Html(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "200px",
    height: "200px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M10.814,11.264l3.267,37.028c0.142,1.608,1.237,2.974,2.776,3.462l11.784,3.734 c2.185,0.692,4.531,0.692,6.716,0l11.784-3.734c1.539-0.488,2.634-1.853,2.776-3.462l3.267-37.028C53.34,9.51,51.958,8,50.197,8 H13.803C12.042,8,10.66,9.51,10.814,11.264z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.142,51.753c1.539-0.488,2.634-1.853,2.776-3.462l1.434-16.255 c-2.739-0.248-5.177,1.79-5.42,4.541l-0.878,9.946c-0.035,0.402-0.309,0.743-0.694,0.865l-7.704,2.441 c-2.469,0.782-4.09,3.28-3.565,5.816c0.021,0.101,0.061,0.191,0.087,0.289c0.736-0.078,1.467-0.223,2.18-0.449L47.142,51.753z",
    opacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.814,11.264l2.182,24.731c0.865-0.079,1.761-0.417,2.691-1.397 c1.317-1.388,1.912-3.315,1.744-5.221l-1.349-15.288C16.031,13.503,16.492,13,17.079,13H23c2.761,0,4.997-2.239,4.997-5H13.803 C12.042,8,10.659,9.51,10.814,11.264z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce29",
    d: "M32,15v33.334c0,1.333,1.28,2.293,2.56,1.92l9.204-2.682c0.793-0.231,1.363-0.927,1.433-1.75 l2.618-30.652c0.1-1.167-0.821-2.17-1.993-2.17H34C32.895,13,32,13.895,32,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,33v-5h9.928c0.58,0,1.038,0.491,0.998,1.069l-0.9,12.986c-0.028,0.405-0.298,0.753-0.684,0.88 L32,46.021v-5.325l5.179-1.775l0.379-5.898L32,33z M43.312,22.075l0.227-2.999C43.584,18.495,43.124,18,42.542,18H32l-0.014,4.986 l10.328,0.013C42.837,23,43.273,22.597,43.312,22.075z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M32,40.716v5.305l-9.344-3.075c-0.384-0.126-0.654-0.472-0.685-0.875l-0.375-4.99 c-0.044-0.58,0.415-1.075,0.997-1.075h3.057c0.519,0,0.952,0.397,0.996,0.914l0.174,2.027L32,40.716z M25.811,22.991H32v-4.982 H21.566c-0.575,0-1.032,0.484-0.998,1.059l0.766,13.001c0.031,0.529,0.469,0.941,0.998,0.941H32v-5.006h-5.811L25.811,22.991z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 20,
    ry: 3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "14.857,17.256 14.349,11.5 19.067,11.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Html);
export default __webpack_public_path__ + "static/media/icons8-html.3651743b37147283ec19f7e2b3a5ee7b.svg";
export { ForwardRef as ReactComponent };